import axios from '@/plugins/axios'
import { Message } from 'element-ui'

export default {
  namespaced: true,

  state: {
    artist: null,
    loading: false
  },

  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    setArtist(state, payload) {
      state.artist = payload
    }
  },

  actions: {
    async readArtist({ commit }) {
      await axios.artist
        .get('myprofile', {
          params: {
            artist:
              this.state.artistDashboard.artist_label !== null
                ? this.state.artistDashboard.artist_label.id
                : null
          }
        })
        .then(r => {
          commit('setArtist', r.data.data[0])
        })
    },
    updateDescription({}, description) {
      axios.artist
        .post('myprofile/description', {
          description: description,
          artist:
            this.state.artistDashboard.artist_label !== null
              ? this.state.artistDashboard.artist_label.id
              : null
        })
        .then(() => {})
    },
    updateSocial({}, social) {
      axios.artist
        .post('myprofile/social', {
          social: social,
          artist:
            this.state.artistDashboard.artist_label !== null
              ? this.state.artistDashboard.artist_label.id
              : null
        })
        .then(() => {})
    },
    sendMessage({ commit }, message) {
      commit('setLoading', true)
      axios.artist
        .post('myprofile/message', {
          text: message.text,
          subject: message.subject
        })
        .then(() => {
          commit('setLoading', false)
          Message({
            type: 'success',
            message: `Message sent successfully`
          })
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  }
}
